const allowQRScanner = (allow_qr_scanner = true, action) => {
    switch (action.type) {
        case "ADD_ALLOW_QR_SCANNER":
            return action.payload;
        default:
            return allow_qr_scanner;
    }
};

export default allowQRScanner;